import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router';

const SupplierDetailsPage = () => {
  const history = useHistory();
  const match = useRouteMatch<{ supplierId: string }>();

  useEffect(() => {
    if (match.isExact) {
      const { supplierId } = match.params;
      history.push(`/app/registry/suppliers/${supplierId}/general`);
    }
  }, [match]);

  return null;
};

export default SupplierDetailsPage;
